export const TITLE = `דוגמה מספרית למשכנתא משלימה`

export const PARAGRAPH = `על מנת לפשט את הנושא, בואו נבין את המשמעות של משכנתא משלימה עם דוגמה מספרית. לדוגמה: נניח ואתם זוג צעיר ורוצים להגשים את החלום של רכישת בית. ההון עצמי שיש ברשותכם הוא 350,000 ₪, במסלול בנקאי רגיל תוכלו לרכוש בית בשווי 1,400,000 ₪ בלבד וזאת באמצעות משכנתא של 75%. עם WeCheck תוכלו לרכוש עם אותו ההון העצמי שברשותכם בית בשווי של 2,340,000 ₪!! בית שאתם באמת רוצים ומתאים לצרכים שלכם ושל משפחתכם. וזאת באמצעות משכנתא משלימה שלWeCheck המאפשרת לקבל מימון עד 85% משווי הנכס ולתקופה של 30 שנה.`

export const CTA_TITLE = `רוצים לקבל הצעה תוך כמה דקות?`

